import { GroupManagementApi } from 'ctp-filter-group-management';
import { routes } from '@/constants/routes/routes';
import userManager from '@/auth';

const apiConfig = {
  accessToken: () => userManager.getApiKey().replace('Bearer ', '')
};

export const GroupManagementApiCaller = new GroupManagementApi(
  apiConfig,
  routes.apiRoutes.basePath
);

export default GroupManagementApiCaller;
